import React from "react"
import { Modal, Table, Button } from "react-bootstrap"
import Json from "react-json-view"
import { size, values } from "lodash"

const DetailsModal = ({ session, onClose }) => (
  <Modal show onHide={onClose} bsSize="large">
    <Modal.Header><Modal.Title>Detalles de la sesión</Modal.Title></Modal.Header>
    <Modal.Body>

      <Table>
        <tbody>
          <tr>
            <th>Id sesión</th>
            <td>{session.id}</td>
          </tr>
          <tr>
            <th>Id cliente</th>
            <td>{session.clientId}</td>
          </tr>
          <tr>
            <th>#tracks</th>
            <td>{session.tracks.length}</td>
          </tr>
          <tr>
            <th>1st timestamp</th>
            <td>{session.firstTimestamp}</td>
          </tr>
          <tr>
            <th>last timestamp</th>
            <td>{session.lastTimestamp}</td>
          </tr>
        </tbody>
      </Table>

      <Table>
        <thead>
          <tr>
            { ["ip", "time", "pathname", "extra"].map(col => <th key={col}>{col}</th>) }
          </tr>
        </thead>
        <tbody>
          {
            session.tracks.map(track => (
              <tr key={track._id}>
                <td>{track.ip}</td>
                <td>{track.timestamp}</td>
                <td>{track.pathname}</td>
                <td>{track.extra}</td>
              </tr>
            ))
          }
        </tbody>
      </Table>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose}>Cerrar</Button>
    </Modal.Footer>
  </Modal>
)

export default DetailsModal



// WEBPACK FOOTER //
// ./src/app/admin/components/tables/TrackingTable.Modal.jsx